import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'sk',
  Pagination: {
    items_per_page: '/ strana',
    jump_to: 'Choď na',
    jump_to_confirm: 'potvrdit',
    page: '',
    prev_page: 'Predchádzajúca strana',
    next_page: 'Nasledujúca strana',
    prev_5: 'Predchádzajúcich 5 strán',
    next_5: 'Nasledujúcich 5 strán',
    prev_3: 'Predchádzajúce 3 strany',
    next_3: 'Nasledujúce 3 strany',
  },
  DatePicker: {
    lang: {
      placeholder: 'Vybrať dátum',
      rangePlaceholder: [
        'Od',
        'Do',
      ],
      locale: 'sk_SK',
      today: 'Dnes',
      now: 'Teraz',
      backToToday: 'Späť na dnes',
      ok: 'Ok',
      clear: 'Vymazať',
      month: 'Mesiac',
      year: 'Rok',
      timeSelect: 'Vybrať čas',
      dateSelect: 'Vybrať dátum',
      monthSelect: 'Vybrať mesiac',
      yearSelect: 'Vybrať rok',
      decadeSelect: 'Vybrať dekádu',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Predchádzajúci mesiac (PageUp)',
      nextMonth: 'Nasledujúci mesiac (PageDown)',
      previousYear: 'Predchádzajúci rok (Control + left)',
      nextYear: 'Nasledujúci rok (Control + right)',
      previousDecade: 'Predchádzajúca dekáda',
      nextDecade: 'Nasledujúca dekáda',
      previousCentury: 'Predchádzajúce storočie',
      nextCentury: 'Nasledujúce storočie',
    },
    timePickerLocale: {
      placeholder: 'Vybrať čas',
    },
  },
  TimePicker: {
    placeholder: 'Vybrať čas',
  },
  Calendar: {
    lang: {
      placeholder: 'Vybrať dátum',
      rangePlaceholder: [
        'Od',
        'Do',
      ],
      locale: 'sk_SK',
      today: 'Dnes',
      now: 'Teraz',
      backToToday: 'Späť na dnes',
      ok: 'Ok',
      clear: 'Vymazať',
      month: 'Mesiac',
      year: 'Rok',
      timeSelect: 'Vybrať čas',
      dateSelect: 'Vybrať dátum',
      monthSelect: 'Vybrať mesiac',
      yearSelect: 'Vybrať rok',
      decadeSelect: 'Vybrať dekádu',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Predchádzajúci mesiac (PageUp)',
      nextMonth: 'Nasledujúci mesiac (PageDown)',
      previousYear: 'Predchádzajúci rok (Control + left)',
      nextYear: 'Nasledujúci rok (Control + right)',
      previousDecade: 'Predchádzajúca dekáda',
      nextDecade: 'Nasledujúca dekáda',
      previousCentury: 'Predchádzajúce storočie',
      nextCentury: 'Nasledujúce storočie',
    },
    timePickerLocale: {
      placeholder: 'Vybrať čas',
    },
  },
  global: {
    placeholder: 'Prosím vyber',
  },
  Table: {
    filterTitle: 'Filter',
    filterConfirm: 'OK',
    filterReset: 'Obnoviť',
    filterEmptyText: 'Žiadne filtre',
    filterCheckAll: 'Vyber všetky položky',
    filterSearchPlaceholder: 'Vyhľadaj vo filtroch',
    emptyText: 'Žiadne dáta',
    selectAll: 'Označ všetky položky',
    selectInvert: 'Opačný výber položiek',
    selectNone: 'Odznač všetko',
    selectionAll: 'Označ všetko',
    sortTitle: 'Zoradiť',
    expand: 'Rozbaliť riadok',
    collapse: 'Zbaliť riadok',
    triggerDesc: 'Kliknutím zoradíš zostupne',
    triggerAsc: 'Kliknutím zoradíš vzostupne',
    cancelSort: 'Kliknutím zrušíš zoradenie',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Zrušiť',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Zrušiť',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    searchPlaceholder: 'Vyhľadávanie',
    itemUnit: 'položka',
    itemsUnit: 'položiek',
    remove: 'Odstráň',
    selectCurrent: 'Vyber aktuálnu stranu',
    removeCurrent: 'Zmaž aktuálnu stranu',
    selectAll: 'Označ všetko',
    removeAll: 'Odznač všetko',
    selectInvert: 'Opačný výber',
  },
  Upload: {
    uploading: 'Nahrávanie...',
    removeFile: 'Odstrániť súbor',
    uploadError: 'Chyba pri nahrávaní',
    previewFile: 'Zobraziť súbor',
    downloadFile: 'Stiahnuť súbor',
  },
  Empty: {
    description: 'Žiadne dáta',
  },
  Icon: {
    icon: 'ikona',
  },
  Text: {
    edit: 'Upraviť',
    copy: 'Kopírovať',
    copied: 'Skopírované',
    expand: 'Zväčšiť',
  },
  PageHeader: {
    back: 'Späť',
  },
  Form: {
    optional: '(nepovinné)',
    defaultValidateMessages: {
      default: 'Validačná chyba poľa pre ${label}',
      required: 'Prosím vlož ${label}',
      enum: '${label} musí byť jeden z [${enum}]',
      whitespace: '${label} nemôže byť prázdny znak',
      date: {
        format: '${label} formát dátumu je neplatný',
        parse: '${label} nie je možné konvertovať na dátum',
        invalid: '${label} je neplatný dátum',
      },
      types: {
        string: '${label} nie je platný ${type}',
        method: '${label} nie je platný ${type}',
        array: '${label} nie je platný ${type}',
        object: '${label} nie je platný ${type}',
        number: '${label} nie je platný ${type}',
        date: '${label} nie je platný ${type}',
        boolean: '${label} nie je platný ${type}',
        integer: '${label} nie je platný ${type}',
        float: '${label} nie je platný ${type}',
        regexp: '${label} nie je platný ${type}',
        email: '${label} nie je platný ${type}',
        url: '${label} nie je platný ${type}',
        hex: '${label} nie je platný ${type}',
      },
      string: {
        len: '${label} musí byť ${len} znakov',
        min: '${label} musí byť aspoň ${min} znakov',
        max: '${label} musí byť do ${max} znakov',
        range: '${label} musí byť medzi ${min}-${max} znakmi',
      },
      number: {
        len: '${label} musí byť rovnaký ako ${len}',
        min: '${label} musí byť minimálne ${min}',
        max: '${label} musí byť maximálne ${max}',
        range: '${label} musí byť medzi ${min}-${max}',
      },
      array: {
        len: 'Musí byť ${len} ${label}',
        min: 'Aspoň ${min} ${label}',
        max: 'Najviac ${max} ${label}',
        range: 'Počet ${label} musí byť medzi ${min}-${max}',
      },
      pattern: {
        mismatch: '${label} nezodpovedá vzoru ${pattern}',
      },
    },
  },
  Image: {
    preview: 'Náhľad',
  },
};

export default localeValues;
